import { ChangeType, TerminalProcedure } from '../models/terminal-procedure.model';
var ProcedureComponent = /** @class */ (function () {
    function ProcedureComponent() {
        this.ChangeType = ChangeType;
        this._selected = false;
    }
    Object.defineProperty(ProcedureComponent.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (value) {
            if (this.procedure.changeType !== ChangeType.Deleted) {
                this._selected = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureComponent.prototype, "active", {
        get: function () {
            return this.procedure.changeType !== ChangeType.Deleted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureComponent.prototype, "type", {
        get: function () {
            return TerminalProcedure.formatProcedureType(this.procedure.type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureComponent.prototype, "changed", {
        get: function () {
            return this.procedure.changeType !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureComponent.prototype, "changeType", {
        get: function () {
            return TerminalProcedure.formatChangeType(this.procedure.changeType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcedureComponent.prototype, "changeTypeTooltip", {
        get: function () {
            switch (this.procedure.changeType) {
                case ChangeType.Added:
                    return 'This procedure was added within the last data cycle.';
                case ChangeType.Changed:
                    return 'This procedure has been changed within the last data cycle.';
                case ChangeType.Deleted:
                    return 'This procedure was recently removed and should no longer be used.';
                default:
                    return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    return ProcedureComponent;
}());
export { ProcedureComponent };
